module.exports = __webpack_public_path__ + "img/check-icon-color.68eb5f0e.svg";